import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const CalculatorCategory = ({ title, image, calculators, categoryPath, icon: Icon }) => {
  return (
    <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl overflow-hidden hover:border-[#3a3a3a] transition-all duration-300 group">
      <Link to={categoryPath} className="block relative overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-[140px] object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-transparent to-transparent" />
      </Link>
      <div className="p-5">
        <Link
          to={categoryPath}
          className="text-white text-lg font-semibold hover:text-cyan-400 transition-colors flex items-center gap-2 mb-4"
        >
          {title}
          <ChevronRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
        </Link>
        <ul className="space-y-2">
          {calculators.map((calc, index) => (
            <li key={index}>
              <Link
                to={calc.path}
                className="text-gray-400 text-sm hover:text-cyan-400 transition-colors flex items-center gap-2"
              >
                <span className="w-1 h-1 bg-cyan-500 rounded-full" />
                {calc.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CalculatorCategory;
